var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTiktokIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 23,
    viewBox: "0 0 24 23",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_13177_102350)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12.0003 23.0006C18.6279 23.0006 24.0006 17.8517 24.0006 11.5003C24.0006 5.14885 18.6279 0 12.0003 0C5.37272 0 0 5.14885 0 11.5003C0 17.8517 5.37272 23.0006 12.0003 23.0006Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.3308 9.56229V8.9346C10.1063 8.90518 9.87811 8.88672 9.64513 8.88672C6.83981 8.88672 4.55762 11.0738 4.55762 13.7623C4.55762 15.4117 5.41788 16.8713 6.72964 17.754C5.88262 16.8828 5.3631 15.7157 5.3631 14.4344C5.3631 11.7846 7.58087 9.62344 10.3308 9.56171V9.56229Z",
    fill: "#25F4EE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.4504 16.6611C11.702 16.6611 12.723 15.7069 12.7694 14.5185L12.7736 3.90258H14.7975C14.7554 3.6845 14.7325 3.46008 14.7325 3.23047H11.9681L11.9639 13.8463C11.9175 15.0354 10.8965 15.989 9.64497 15.989C9.25607 15.989 8.88945 15.8956 8.56738 15.7334C8.98999 16.2942 9.67567 16.6617 10.451 16.6617L10.4504 16.6611Z",
    fill: "#25F4EE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.5778 7.50508V6.91489C17.806 6.91489 17.0866 6.69509 16.4834 6.31836C17.0204 6.90912 17.75 7.33547 18.5778 7.50508Z",
    fill: "#25F4EE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.4841 6.31848C15.8959 5.67118 15.5383 4.82599 15.5383 3.90234H14.7979C14.9929 4.91137 15.6178 5.77733 16.4841 6.31848Z",
    fill: "#FE2C55"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.64502 11.5357C8.36396 11.5357 7.32129 12.5343 7.32129 13.7626C7.32129 14.6176 7.82757 15.3607 8.56683 15.7333C8.29111 15.3676 8.12677 14.9193 8.12677 14.4347C8.12677 13.207 9.16943 12.2078 10.4505 12.2078C10.6895 12.2078 10.9189 12.2459 11.1362 12.3105V9.60648C10.9116 9.57706 10.6835 9.55859 10.4505 9.55859C10.4102 9.55859 10.3704 9.5609 10.3301 9.56148V11.6384C10.1134 11.5732 9.88341 11.5357 9.64441 11.5357H9.64502Z",
    fill: "#FE2C55"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.5781 7.50586V9.56488C17.1447 9.56488 15.8167 9.12527 14.7325 8.37989V13.7631C14.7325 16.4516 12.4503 18.6387 9.64499 18.6387C8.56078 18.6387 7.55544 18.311 6.72949 17.7548C7.65898 18.7108 8.98278 19.3108 10.4511 19.3108C13.2564 19.3108 15.5386 17.1237 15.5386 14.4352V9.052C16.6228 9.79796 17.9508 10.237 19.3842 10.237V7.58778C19.1079 7.58778 18.8382 7.55894 18.5787 7.50586H18.5781Z",
    fill: "#FE2C55"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.7328 13.7625V8.37923C15.817 9.12518 17.1451 9.56422 18.5784 9.56422V7.5052C17.7507 7.33558 17.021 6.90924 16.4841 6.31848C15.6178 5.77733 14.9929 4.91137 14.7979 3.90234H12.7739L12.7697 14.5182C12.7234 15.7072 11.7024 16.6609 10.4508 16.6609C9.67542 16.6609 8.98974 16.294 8.56713 15.7326C7.82727 15.3594 7.32159 14.6169 7.32159 13.7619C7.32159 12.5342 8.36426 11.535 9.64532 11.535C9.88431 11.535 10.1137 11.573 10.331 11.6377V9.56076C7.58106 9.62249 5.36328 11.7836 5.36328 14.4334C5.36328 15.7153 5.88281 16.8818 6.72982 17.753C7.55637 18.3091 8.56111 18.6368 9.64532 18.6368C12.4506 18.6368 14.7328 16.4497 14.7328 13.7613V13.7625Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_13177_102350"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 23,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTiktokIcon);
export default __webpack_public_path__ + "static/media/tiktok_icon.45f83cc2964bef6eb806539477b010bd.svg";
export { ForwardRef as ReactComponent };